export enum Errors {
  passwordConfirmation = "Passwords must match",
  passwordMin = "Password should be more than 10 characters",
  passwordWhiteSpace = "Password can't contain spaces",
  passwordLetterUppercaseAndLowercase = "Passwords need both upper and lowercase letters",
}
